"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillViewStyled = void 0;
const constants_1 = require("../../theme/constants");
exports.SkillViewStyled = styled.div.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 1.5em;
  align-items: stretch;
  justify-content: flex-start;

  >.category {
    >.category-name {
      font-weight: bold;
    }
  }

  >.controls {
    display: flex;
    gap: 1em;
    justify-content: space-between;

    @media (min-width: ${constants_1.sizes.tablet}) {
      flex-flow: row nowrap;
      align-items: center;
    }

    @media (max-width: ${constants_1.sizes.tablet}) {
      flex-flow: column nowrap;
      align-items: stretch;
    }
  }
}
`;
//# sourceMappingURL=SkillView.styled.js.map